import axiosInstance from "../../../util/axiosInstance";

export const upload_catering_menu_fromfile = async(file)=>{
    try {
        const response = await axiosInstance.post('/catering-items/upload-catering-menu',file)
        return response.data
    } catch (error) {
        console.warn("got error on uploading catering file",error)
        return error
    }
}

export const getcateringitemlist = async(exclude)=>{
    try {
        const response = await axiosInstance.get(`/catering-items/mst-list/new?exclude_side_items=${exclude}`,)
        return response.data
    } catch (error) {
        console.warn("got error on fetching catering items",error)
        return error
    }
}

export const createcatering_items = async(data)=>{
    try {
        const response = await axiosInstance.post(`/catering-items//master`,data)
        return response.data
    } catch (error) {
        console.warn("got error on fetching catering items",error)
        return error
    }
}

export const updatecatering_items = async(data,id)=>{
    try {
        const response = await axiosInstance.put(`/catering-items//master/${id}`,data)
        return response.data
    } catch (error) {
        console.warn("got error on fetching catering items",error)
        return error
    }
}

export const deletecatering_items = async(id)=>{
    try {
        const response = await axiosInstance.delete(`/catering-items//master/${id}`)
        return response.data
    } catch (error) {
        console.warn("got error on fetching catering items",error)
        return error
    }
}


export const cuisinecategory = async(id)=>{
    try {
        const response = await axiosInstance.get(`/cuisine/categories`)
        return response.data
    } catch (error) {
        console.warn("got error on fetching catering items",error)
        return error
    }
}

